<template>
  <div class="modal-wrapper">
    <div class="modal-dialog  extra-large-modal" role="document">
      <div class="modal-content modal-content--scrollable">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Marcar mensalidade como paga
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="table-centralized">
                  Id
                </th>
                <th class="table-centralized">
                  Status
                </th>
                <th class="table-centralized">
                  Data de vencimento
                </th>
                <th class="table-centralized">
                  Data do pagamento
                </th>
                <th class="table-centralized">
                  Valor devido no pagamento
                </th>
                <th class="table-centralized">
                  Valor pago
                </th>
              </tr>
            </thead>
            <tbody class="table-centralized">
              <tr>
                <td>{{ selectedBill.id }}</td>
                <td>{{ selectedBill.translated_status }}</td>
                <td>{{ selectedBill.due_date | formatDate }}</td>
                <td>{{ paymentDetails.paid_date | formatDate }}</td>
                <td>{{ paymentDetails.amount | formatCurrency }}</td>
                <td>{{ paymentDetails.paid_amount | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div v-show="inputError" class="alert alert-danger" v-html="inputError"></div>
          <div v-if="underpayment">
            <div class="select-underpayment-type">
              <p>Selecione o que fazer com o valor devido dessa mensalidade:</p>
              <input v-model="underpaymentType"
                     id="forgiving" value="forgiving"
                     class="select-underpayment-type__input"
                     type="radio"
              >
              <label for="forgiving">Não cobrar o valor devido</label>
              <br>
              <input v-model="underpaymentType"
                     id="transfering"
                     value="transfering"
                     class="select-underpayment-type__input"
                     type="radio"
              >
              <label for="transfering">Transferir o valor devido para outra mensalidade</label>
            </div>
            <div v-if="transferingDebt">
              <p>Selecione a mensalidade que receberá o valor:</p>
              <table class="table table-striped table-transfering-debt">
                <thead>
                  <tr>
                    <th class="table-centralized"></th>
                    <th class="table-centralized">
                      ID
                    </th>
                    <th class="table-centralized">
                      Tipo
                    </th>
                    <th class="table-centralized">
                      Vencimento
                    </th>
                    <th class="table-centralized">
                      Mesmo contrato
                    </th>
                    <th class="table-centralized">
                      Valor atual
                    </th>
                    <th class="table-centralized">
                      Novo valor
                    </th>
                  </tr>
                </thead>
                <tbody class="table-centralized">
                  <tr v-for="billToReceiveValue in bills" :key="billToReceiveValue.id">
                    <td>
                      <input v-model="billToReceiveAmountId" :value="billToReceiveValue.id" type="radio">
                    </td>
                    <td>{{ billToReceiveValue.id }}</td>
                    <td>{{ billToReceiveValue.translated_bill_type }}</td>
                    <td>{{ billToReceiveValue.due_date | formatDate }}</td>
                    <td>{{ (billToReceiveValue.contract_id == selectedBill.contract_id) | formatBoolean }}</td>
                    <td>{{ billToReceiveValue.amount_with_charges | formatCurrency }}</td>
                    <td>{{ calculateNewValue(billToReceiveValue) | formatCurrency }}</td>
                  </tr>
                  <tr>
                    <th colspan="6">
                      Valor para adicionar à mensalidade
                    </th>
                    <td>
                      <strong>
                        {{ paymentDetails.remaining_amount | formatCurrency }}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <p>Descreva o que motivou a mudança de status:</p>
            <input @click="inputError = null" class="form-input" type="text" v-model="observations">
          </div>
          <div v-if="correctlyPaid">
            <p class="modal-legend">
              <strong>ATENÇÃO:</strong>
              Mensalidade corretamente paga, não será necessário fazer ajustes no valor da mensalidade.
            </p>
          </div>
          <div v-else-if="overpayment">
            <p class="modal-legend">
              <strong>ATENÇÃO:</strong>
              Não existe uma forma forçada para transferir créditos entre mensalidades, sendo assim, somente quando a
              IES tiver a configuração que autorize a transferência de valores ela será executada. Na ausência da
              configuração a mensalidade continua sendo marcada como paga, mas a diferença, entre o valor devido e o
              valor pago, não é zerada.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="processPayments">
            Aplicar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      billToReceiveAmountId: null,
      inputError: '',
      observations: null,
      underpaymentType: null,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
      'studentBills',
      'paymentDetails',
      'studentContracts',
    ]),
    contract() {
      return this.studentContracts.find(contract => contract.id === this.selectedBill.contract_id);
    },
    contractIds() {
      return this.studentContracts
        .filter(contract => contract.billing_id === this.contract.billing_id)
        .map(contract => contract.id);
    },
    bills() {
      return this.studentBills.filter(bill => (bill.id !== this.selectedBill.id)
        && this.contractIds.includes(bill.contract_id)
        && (bill.status === 'open'))
        .sort((a, b) => a.contract_id - b.contract_id);
    },
    correctlyPaid() {
      return this.paymentDetails.remaining_amount === 0;
    },
    underpayment() {
      return (this.paymentDetails.remaining_amount !== 0)
        && (this.paymentDetails.amount > this.paymentDetails.paid_amount);
    },
    overpayment() {
      return (this.paymentDetails.remaining_amount !== 0)
        && (this.paymentDetails.amount < this.paymentDetails.paid_amount);
    },
    forgivingDebt() {
      return this.underpayment && (this.underpaymentType === 'forgiving');
    },
    transferingDebt() {
      return this.underpayment && (this.underpaymentType === 'transfering');
    },
  },
  watch: {
    billToReceiveAmountId() {
      this.inputError = null;
    },
    observations() {
      this.inputError = null;
    },
    underpaymentType() {
      this.inputError = null;
    },
  },
  methods: {
    calculateNewValue(bill) {
      if (this.billToReceiveAmountId === bill.id) {
        return bill.amount_with_charges + this.paymentDetails.remaining_amount;
      }

      return bill.amount_with_charges;
    },
    valid() {
      this.inputError = '';

      if (this.underpayment && !this.underpaymentType) {
        this.inputError += '<p>- Selecione o que vai ser feito com o valor que falta ser pago</p>';
      }
      if (this.transferingDebt && !this.billToReceiveAmountId) {
        this.inputError += '<p>- Uma mensalidade deve ser selecionada para transferir o valor devido</p>';
      }
      if (!this.observations) {
        this.inputError += '<p>- É necessário especificar o que motivou a mudança de status</p>';
      }

      if (this.inputError !== '') return false;

      this.inputError = null;
      return true;
    },
    processPayments() {
      const modal = this.$el.querySelector('.modal-body');

      if (!this.valid()) {
        modal.scrollTop = 0;
        return;
      }

      if (this.correctlyPaid || this.overpayment) {
        this.processRequest(BillsService.processPayments(this.selectedBill.id, this.observations));
      } else if (this.forgivingDebt) {
        this.processRequest(BillsService.processPaymentsForgivingDebt(this.selectedBill.id, this.observations));
      } else if (this.transferingDebt) {
        this.processRequest(BillsService.processPaymentsTransferingDebt(
          this.selectedBill.id,
          this.billToReceiveAmountId,
          this.observations,
        ));
      }
    },
    processRequest(request) {
      this.$loader.show();

      request
        .then(() => {
          this.$alert.notifySuccess('A mensalidade foi marcada como paga');
          this.$emit('close');
        })
        .catch(({ response: { data } }) => {
          this.$alert.notifyAlert(data.message);
          this.$emit('close');
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped>
.select-underpayment-type {
  margin-bottom: 10px;
}
.select-underpayment-type__input {
  margin: 0px 10px 0px 20px;
}
.alert-danger {
  margin-top: 10px;
}
.form-input {
  margin-top: 0px;
}
</style>
